import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './SessionsList.css';

function SessionsList() {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetch('/api/sessions')
      .then(res => res.json())
      .then(data => {
        setSessions(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const formatDate = (dateStr) => {
    const d = new Date(dateStr);
    const mon = d.toLocaleString('en-US', { month: 'short' });
    const day = d.getDate();
    const time = d.toLocaleString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true }).toLowerCase();
    return `${mon} ${day} ${time}`;
  };

  if (loading) {
    return <div className="cl-page"><div className="cl-loading">loading...</div></div>;
  }

  return (
    <div className="cl-page">
      <div className="cl-header">
        <h1 className="cl-title" onClick={() => navigate('/')}>endotica</h1>
        <span className="cl-subtitle">sessions</span>
      </div>
      <div className="cl-banner">
        {sessions.length} session{sessions.length !== 1 ? 's' : ''} found
      </div>
      <table className="cl-table">
        <thead>
          <tr>
            <th className="cl-th cl-th-date">date</th>
            <th className="cl-th cl-th-title">session</th>
            <th className="cl-th cl-th-user">user</th>
            <th className="cl-th cl-th-count">imgs</th>
          </tr>
        </thead>
        <tbody>
          {sessions.map((s) => (
            <tr key={s.code} className="cl-row" onClick={() => navigate(`/s/${s.code}`)}>
              <td className="cl-td cl-date">{formatDate(s.createdAt)}</td>
              <td className="cl-td cl-link">{s.title || s.code}</td>
              <td className="cl-td cl-user">{s.username}</td>
              <td className="cl-td cl-count">{s.imageCount}</td>
            </tr>
          ))}
          {sessions.length === 0 && (
            <tr><td className="cl-td cl-empty" colSpan="4">no sessions yet</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default SessionsList;
